<template>
  <div class="max-w-4xl mx-auto">
    <Head title="Crear productos" />
    
    <!-- Header -->
    <div class="flex items-center gap-4 mb-8">
      <button 
        class="p-3 text-white bg-teal-700 hover:bg-teal-800 rounded-lg transition-colors"
        title="Volver atrás"
        @click="back()"
      >
        <i class="fa fa-arrow-left"></i>
      </button>
      <h1 class="text-3xl font-bold">
        <Link 
          class="text-teal-600 hover:text-teal-700 transition-colors" 
          href="/products"
        >
          Productos
        </Link>
        <span class="text-gray-400 font-medium mx-2">/</span>
        <span>Crear</span>
      </h1>
    </div>

    <!-- Form -->
    <div class="max-w-4xl bg-white rounded-lg shadow-sm border border-gray-200">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/2" label="Codigo" />
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Descripcion" />
          <text-input v-for="(group, key) in groups" :key="key" v-model="form.prices[key]" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2" :label="`Precio ${group.name}`" />
          <text-input v-model="form.price_cop" :error="form.errors.price_cop" class="pb-8 pr-6 w-full lg:w-1/2" label="Precio en pesos" />
          <text-input v-model="form.cost" :error="form.errors.cost" class="pb-8 pr-6 w-full lg:w-1/2" label="Costo" />
          <!-- <text-input v-model="form.line_name" :error="form.errors.line_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre de linea" /> -->
          <!-- <text-input v-model="form.alias" :error="form.errors.alias" class="pb-8 pr-6 w-full lg:w-1/2" label="Alias" /> -->
          <select-input v-model="form.brand_id" :error="form.errors.brand_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Marca">
            <option value="">Seleccionar</option>
            <option v-for="(brand, key) in brands" :key="key" :value="brand.id">{{ brand.name }}</option>
          </select-input>
          <select-input v-model="form.product_category_id" :error="form.errors.product_category_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Categoria">
            <option value="">Seleccionar</option>
            <option v-for="(productCategory, key) in productCategories" :key="key" :value="productCategory.id">{{ productCategory.name }}</option>
          </select-input>
          <select-input v-model="form.contable" :error="form.errors.contable" class="pb-8 pr-6 w-full lg:w-1/2" label="Contable">
            <option value="">Seleccionar</option>
            <option value="0">No</option>
            <option value="1">Si</option>
          </select-input>
          <select-input v-model="form.is_decimal" :error="form.errors.is_decimal" class="pb-8 pr-6 w-full lg:w-1/2" label="¿Se vende en decimales?">
            <option value="">Seleccionar</option>
            <option :value="true">Si</option>
            <option :value="false">No</option>
          </select-input>
          <text-input v-model="form.min_stock" :error="form.errors.min_stock" class="pb-8 pr-6 w-full lg:w-1/2" label="Stock Mínimo (Piso)" type="number" />
          <text-input v-model="form.max_stock" :error="form.errors.max_stock" class="pb-8 pr-6 w-full lg:w-1/2" label="Stock Máximo (Techo)" type="number" />
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
        </div>

        <!-- Submit -->
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button 
            :loading="form.processing" 
            class="px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-lg transition-colors"
            type="submit"
          >
            Crear producto
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    groups: {
      type: Object,
      required: true
    },
    brands: {
      type: Object,
      required: true
    },
    productCategories: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: this.$inertia.form({
        code: '',
        name: '',
        description: '',
        prices: this.groups.map(() => 0),
        brand_id: '',
        volumen: '',
        weight: '',
        quantity: 0,
        contable: 1,
        alias: '',
        line_name: '',
        cost: 0,
        price_cop: 0,
        product_category_id: '',
        is_decimal: false,
        min_stock: 5,
        max_stock: 100,
        photo: null
      }),
    }
  },
  methods: {
    back() {
      window.history.back()
    },
    store() {
      this.form.post('/products')
    },
  },
}
</script>
